import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

let loaded = false;

export async function loadGoogleMaps() {
  if (loaded) return;

  const apiKey ="AIzaSyBJyBb889wYsxQf7KFRDTwsN1LrBea_b4g";
  setOptions({
    key: apiKey,
    v: "weekly",
    libraries: ["places"],
  });

  await importLibrary("maps");
  await importLibrary("places");

  loaded = true;
}

